import AbstractChannel from './AbstractChannel'

export default class ParkNFly extends AbstractChannel {

  name = 'park_n_fly'
  title = 'Park \'N Fly'
  titleShort = 'Park \'N Fly'
  color = '#f7b6d2'

}
